<template>
    <hts-router-drawer
        :title="$t('labels.editCommodity')"
        :size="50"
        :rules="rulesCooperatorCommodity"
        :submit="submit"
        is-close
        @loaded="getData"
        @refresh-tables="refreshTables">
        <hts-form-select
            v-model="dataFormEditCommodity.category"
            :label="$t('labels.category')"
            required
            :items="listCategory"
            key-id="label"
            key-label="label"
            prop="category"
            filterable
            name="category"
            :color="props.color" />
        <hts-form-input
            v-model="dataFormEditCommodity.commodity"
            :label="$t('labels.name')"
            :required="true"
            prop="commodity"
            name="commodity"
            :color="props.color" />
    </hts-router-drawer>
</template>

<script setup lang="ts">
import listCategory from '@/data/commodity/category.json'
import { IEditCommodity } from '~/pages/trucker-[id]/partner/-components/imports/form'

const rulesCooperatorCommodity = {
  commodity: 'required',
  category: 'required'
}

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})

const visible = ref(false)
const codeCommodity = computed(() => useRoute().params.idcommodity)
const codeCooperator = computed(() => useRoute().params.idpartner)
const resetForm = () => {
  Object.assign(dataFormEditCommodity, {
    cooperator: '',
    commodity: '',
    category: ''
  })
}
const dataFormEditCommodity = reactive<IEditCommodity>({
  cooperator: '',
  commodity: '',
  category: ''
})

const emits = defineEmits(['close', 'refreshTables'])

const close = () => {
  resetForm()
  visible.value = false
}

const refreshTables = () => {
  emits('refreshTables')
}

const submit = async () => {
  const api = {
    url: '/partner/commodity/cooperatorID/update/commodityID',
    method: 'put'
  }
  const data: any = await $api(api, { uriParams: { cooperatorID: codeCooperator.value, commodityID: codeCommodity.value }, body: dataFormEditCommodity })
  const resData = data?.data?.value

  if (resData && resData.success) {
    if (resData.success) {
      resetForm()
      process.client && $toast().success($t('labels.updateCommoditySuccess'))
    }
  }
}

const getData = () => {
  const api = $url.partner.commodity.getDetail
  $api(api, { uriParams: { cooperatorId: codeCooperator.value, ID: codeCommodity.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataFormEditCommodity, { ...resData.data })
      }
    })
    .catch(() => {})
}
</script>
